import { useTranslation } from 'react-i18next'
import { KILO } from '../../constants/KILO_THEME'
import {
  formatPrescriptionDetail,
  parsePrescriptionWeightKg,
} from '../../lib/prescriptionFormat'

type PrescriptionLoadProps = {
  prescription: string
  size?: 'lg' | 'sm'
}

/** Prominent target load + prescription detail for workout cards. */
export function PrescriptionLoad({ prescription, size = 'lg' }: PrescriptionLoadProps) {
  const { t } = useTranslation()
  const loadKg = parsePrescriptionWeightKg(prescription)
  const detail = formatPrescriptionDetail(prescription)

  if (loadKg == null) {
    return <p className={`font-mono ${size === 'lg' ? 'text-sm' : 'text-xs'} text-kilo-accent`}>{prescription}</p>
  }

  return (
    <div className="space-y-1">
      <p className={`${KILO.meta} text-kilo-muted`}>{t('coach.dashboard.targetLoad')}</p>
      <p
        className={`font-black tabular-nums text-kilo-accent ${
          size === 'lg' ? 'text-4xl tracking-tight' : 'text-2xl'
        }`}
      >
        {loadKg} kg
      </p>
      {detail ? (
        <p className={`font-mono ${size === 'lg' ? 'text-sm' : 'text-xs'} ${KILO.text.muted}`}>{detail}</p>
      ) : null}
    </div>
  )
}
